import { Tooltip } from "@material-ui/core";
import TeacherPortalVerticalProgressBarWithTooltip from "../../general/progress_bar/VerticalProgressBarWithTooltip";


const TeacherPortalQuestionStatisticsOption = ({ option, amount_chosen, amount_total, point_worth }) => {

    const chosen_ratio = amount_total == 0 ? 0 : amount_chosen / amount_total;

    return (<>
        <div className={"mb-4 rounded shadow border border-[#f2f2f2] pl-2 pb-2 " + (point_worth ? "bg-[#16CC64]" : "bg-error")}>
            <div className="grid grid-cols-12">
                <div className="col-span-8">
                    <p dangerouslySetInnerHTML={{ __html: option }} />
                </div>
                <div className="col-span-1">
                    {point_worth ? <p>(Correct)</p> : <p>(Wrong)</p>}
                </div>
                <div className="col-span-1">
                    <Tooltip title={amount_chosen + " out of " + amount_total + " students chose this answer"}><p>
                        {amount_chosen} / {amount_total}
                    </p>
                    </Tooltip>
                </div>
                <div className="col-span-2">
                    <TeacherPortalVerticalProgressBarWithTooltip floatProgress={chosen_ratio} tooltipString={Math.round(100 * chosen_ratio) + "% of students chose this answer"} />
                </div>
            </div>
        </div>
    </>
    )

};

export default TeacherPortalQuestionStatisticsOption